module.exports = __webpack_public_path__ + "img/um.13700d16.svg";